export default __webpack_public_path__ + "static/media/unsuccessfulPayment.c3175358.gif";